import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'search/FETCH_REQUEST';
const FETCH_SUCCESS = 'search/FETCH_SUCCESS';
const FETCH_FAILURE = 'search/FETCH_FAILURE';

const initialState = {
  result: {
    source_types: [],
    candidate_source_options: [],
    qualifications_list: {},
    skill_and_experiences_list: [],
    job_titles_list: {
      director_positions: [],
      superannuation_director_positions: [],
      government_director_positions: [],
      other_government_director_positions: [],
      nfp_director_positions: [],
      csuite_positions: { major: [], minor: [] }
    },
    industry_classifications: [],
    private_classifications: [],
    superannuation_classifications: [],
    government_classifications: [],
    other_government_classifications: [],
    nfp_classifications: [],
    company_top_filter_options: {
      min_market_cap: [],
      max_market_cap: [],
      min_age: [],
      max_age: [],
      min_time: [],
      max_time: [],
      min_base_rem: [],
      max_base_rem: [],
      min_rem: [],
      max_rem: []
    },
  },
  loaded: false,
  loading: false,
  errors: []
};

export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST
  }
}

export function fetchSuccess(payload){
  return {
    type: FETCH_SUCCESS,
    payload
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors
  }
}

export function loadSearchData(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest());
    
    return api('api/v1/searches/', options, {}, true)
    .then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json)
      }
      
      dispatch(fetchSuccess(json))
    })
    .catch((exception) => {
      handleAPIErrors(exception, (errors) => {
        dispatch(fetchFailure(errors))
      })
    });
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;
  
  switch (type) {
    case FETCH_REQUEST:
    return Object.assign({}, state, {
      loading: true
    });
    case FETCH_SUCCESS:
    return Object.assign({}, state, {
      loading: false,
      loaded: true,
      errors: [],
      result: payload
    });
    case FETCH_FAILURE:
    return Object.assign({}, state, {
      loaded: false,
      loading: false,
      errors
    });
    default:
    return state
  }
}